/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { MEDIA_MIN_WIDTH } from '../../../constants';

type Props = {
  heading: string;
  description: string;
  logos: {
    url: string;
    altText: string;
  }[];
};

const Styles = labelStyles('Sponsors', {
  root: css({
    margin: 'auto',
    maxWidth: '1210px',
    padding: '100px 20px 97px 20px',

    [MEDIA_MIN_WIDTH.large]: {
      padding: '115px 20px',
    },
  }),
  heading: css({
    color: Colors.earth,
    fontFamily: Typography.heading.fontFamily,
    fontSize: '40px',
    letterSpacing: '1.5px',
    lineHeight: '110%',
    margin: 'auto',
    paddingBottom: '19px',
    textAlign: 'center',
    width: '79%',
    maxWidth: '611px',

    [MEDIA_MIN_WIDTH.small]: {
      paddingBottom: '22px',
    },
  }),
  description: css({
    color: Colors.earth,
    fontSize: '18px',
    fontFamily: Typography.base.fontFamily,
    margin: 'auto',
    paddingBottom: '48px',
    textAlign: 'center',
    width: '93%',
    maxWidth: '611px',

    [MEDIA_MIN_WIDTH.small]: {
      paddingBottom: '51px',
    },

    [MEDIA_MIN_WIDTH.large]: {
      paddingBottom: '66px',
    },
  }),
  logoContainer: css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '30px 49px',
    margin: 'auto',
    maxWidth: 'max-content',

    [MEDIA_MIN_WIDTH.small]: {
      gap: '50px 84px',
    },

    [MEDIA_MIN_WIDTH.large]: {
      display: 'flex',
      maxWidth: '100%',
      justifyContent: 'center',
    },
  }),
  logo: css({
    borderRadius: '3px',
    overflow: 'hidden',

    img: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },

    [MEDIA_MIN_WIDTH.small]: {
      maxHeight: '140px',
      maxWidth: '211px',
    },
  }),
});

export function Sponsors({ heading, description, logos }: Props) {
  return (
    <div css={Styles.root}>
      <div>
        <h2 css={Styles.heading}>{heading}</h2>
        <p css={Styles.description}>{description}</p>
      </div>
      <div css={Styles.logoContainer}>
        {logos?.map((logo, index) => (
          <div css={Styles.logo} key={`${logo.url}-${index}`}>
            <img src={logo.url} alt={logo.altText} />
          </div>
        ))}
      </div>
    </div>
  );
}
